import _ from 'lodash';
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { fetchArticle, receiveArticleError } from './action-article';
import { updateUserSelection } from './action-update-user-selection';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const CANCEL_TOPIC_MESSAGE = 'cancel topic request';

function requestTopicData(id) {
  return {
    type: types.REQUEST_TOPIC_DATA,
    payload: { id },
  };
}

function receiveTopicData(responseData) {
  const contactChannel = _.get(responseData, 'formInfo.form_elements.contact_channel', {});
  return {
    type: types.RECEIVE_TOPIC_DATA_RESPONSE,
    payload: contactChannel,
  };
}

function receiveFormFields(responseData) {
  const formFields = _.get(responseData, 'formInfo.form_elements.webform_detail', []);
  const kanaCode = _.get(responseData, 'formInfo.kana_code', '');
  const topicRefId = _.get(responseData, 'formInfo.topicRefId', '');
  return {
    type: types.RECEIVE_FORM_FIELDS,
    payload: {
      kanaCode,
      formFields,
      topicRefId,
    },
  };
}

function receiveTopicDataError() {
  return {
    type: types.RECEIVE_TOPIC_DATA_ERROR,
    payload: undefined,
  };
}

function receiveFAQID(faqId) {
  return {
    type: types.RECEIVE_FAQID,
    payload: faqId,
  };
}

function receiveFAQIDError() {
  return {
    type: types.NO_FAQID,
    payload: undefined,
  };
}

function fetchFAQIDData(responseData) {
  return (dispatch) => {
    const faqId = _.get(responseData, 'formInfo.form_elements.faqid[0].default_text', undefined);
    if (faqId) {
      dispatch(fetchArticle(faqId));
      dispatch(receiveFAQID(faqId));
    } else {
      dispatch(receiveFAQIDError());
      dispatch(receiveArticleError());
    }
  };
}

function fetchTopicData(topicId) {
  return (dispatch) => {
    dispatch(requestTopicData(topicId));
    return axios.get(`/smarthelp/topic-data/?topic_id=${topicId}`, {
      cancelToken: source.token,
    })
    .then((response) => {
      dispatch(receiveTopicData(response.data));
      dispatch(receiveFormFields(response.data));
      dispatch(fetchFAQIDData(response.data));
      dispatch(updateUserSelection());
    })
    .catch((error) => {
      if (error && error.message !== CANCEL_TOPIC_MESSAGE) {
        dispatch(receiveTopicDataError());
      }
      dispatch(receiveArticleError());
    });
  };
}

function cancelTopicDataRequest() {
  source.cancel(CANCEL_TOPIC_MESSAGE);
}

module.exports = {
  fetchTopicData,
  cancelTopicDataRequest,
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-topic-data.js